import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { TranslateService } from '@ngx-translate/core'
import { Subscription } from 'rxjs'
import { clientPayout } from 'src/app/modules/payout/models/client-payout'
import { PayoutService } from 'src/app/modules/payout/services/payout.service'
import { environment } from 'src/environments/environment'

@Component({
	selector: 'app-client-profile-payout-details',
	templateUrl: './client-profile-payout-details.component.html',
	styleUrls: ['./client-profile-payout-details.component.scss'],
})
export class ClientProfilePayoutDetailsComponent implements OnInit {
	@Input() clientDeatailsData!: clientPayout
	@Output() isFlipped = new EventEmitter()
	subscription = new Subscription()
	imagePath = environment.attachmentPath
	countryId: any
	clientId: any
	constructor(
		private payoutService: PayoutService,
		private routeActivate: ActivatedRoute,
		public translate: TranslateService
	) {}

	ngOnInit(): void {
		this.routeActivate.params.subscribe(({ id }) => {
			this.clientId = id
			this.subscription.add(
				this.routeActivate.queryParams.subscribe((res) => {
					this.countryId = res['country']
				})
			)
		})
	}
	getDetails(id: number) {
		this.subscription.add(
			this.payoutService.getClientPayoutDetails(id).subscribe((res: any) => {
				this.clientDeatailsData = res.result
			})
		)
	}
}
